<template>
	<div contenteditable="true"
		ref="editableTextEl"
		@keydown="onOrderNumberKeyup"
		@keyup="onOrderNumberKeyup"
		@paste="onOrderNumberPaste" class="editable">
	</div>
</template>


<script lang="ts">
import { WatchStopHandle } from 'vue';
import { Options, Vue } from 'vue-class-component';

@Options({	
	props: {
		modelValue: {
			type: String,
			default: ''
		}
	},
	emits: ['update:modelValue', 'changed']
})
export default class TextEditableComponent extends Vue {
	/** props */
	modelValue!: string;

	/** constants */
	maxLength = 32;

	/** view-models */
	internalValue: string | null = null;
	valueWatchHandler?: WatchStopHandle;

	mounted(): void {		
		// this.valueWatchHandler = watch(
		// 	() => this.modelValue,
		// 	(v) => {
		// 		this.internalValue = v;
		// 		const editableTextEl = this.$refs.editableTextEl as HTMLElement;
		// 		editableTextEl.textContent = v;
		// 	} 
		// );

		this
			.$nextTick()
			.then(() => {
				if (this.modelValue) {
					this.internalValue = this.modelValue;
					const editableTextEl = this.$refs.editableTextEl as HTMLElement;
					editableTextEl.textContent = this.modelValue;
				}
			});
	}

	unmounted(): void {
		if (this.valueWatchHandler) {
			this.valueWatchHandler();
		}
	}

    onOrderNumberKeyup(e: KeyboardEvent) {		
		const srcElement = e.target as HTMLElement;
		if (e.key === 'Enter' || e.keyCode === 13) {
			e.preventDefault();
			return false;
		}

		if((e.key !== 'Backspace' || e.keyCode !== 8) && 
			srcElement.innerText.length > this.maxLength)
		{
			e.preventDefault();
			return false;
		}

		this.internalValue = (e.target as HTMLElement).textContent;
		this.$emit('update:modelValue', this.internalValue);
	}

	onOrderNumberPaste(e: ClipboardEvent) {
		const clipboardText = e.clipboardData?.getData("text") ?? '';

		const tempDiv = document.createElement("input");
		tempDiv.value = clipboardText;
		
		const sanitizedPastedText = tempDiv.value.substring(0, this.maxLength);
		this.internalValue = sanitizedPastedText;
		(e.target as HTMLElement).textContent = sanitizedPastedText;
		this.$emit('update:modelValue', this.internalValue);
		e.preventDefault();
		return false;
	}
}
</script>

<style scoped>
	.editable {
		outline: none;
		cursor: text;
	}
</style>